import { isSunmiDevice } from "../../../utils/sunmiPrinter";

interface StatusBarProps {
  mode: "sale" | "tender" | "return";
}

export default function StatusBar({ mode }: StatusBarProps) {
  const userName = (() => {
    try {
      const profile = JSON.parse(
        localStorage.getItem("clientBusinessProfile") || "{}",
      );
      return profile?.userName || "";
    } catch {
      return "";
    }
  })();

  return (
    <div className="bg-gray-800 text-white px-6 py-2.5 flex items-center justify-between border-t border-gray-700">
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2">
          <span className="text-xs text-gray-400 whitespace-nowrap">
            Current Mode:
          </span>
          <span
            className={`px-3 py-1 rounded-full text-xs font-bold whitespace-nowrap ${
              mode === "sale"
                ? "bg-teal-500 text-white"
                : mode === "tender"
                  ? "bg-green-500 text-white"
                  : "bg-cyan-500 text-white"
            }`}
          >
            {mode === "sale" ? "SALE" : mode === "tender" ? "TENDER" : "RETURN"}
          </span>
        </div>

        <div className="h-5 w-px bg-gray-600"></div>

        <div className="flex items-center gap-2">
          <span className="text-xs text-gray-400 whitespace-nowrap">
            User Role:
          </span>
          <span className="text-xs font-semibold text-white whitespace-nowrap">
            Cashier
          </span>
        </div>
      </div>

      <div className="flex items-center gap-4">
        {isSunmiDevice() && (
          <button
            onClick={() => window.location.reload()}
            className="w-7 h-7 flex items-center justify-center hover:bg-gray-600 rounded-full transition-colors cursor-pointer"
            title="Reload"
          >
            <i className="ri-refresh-line text-gray-400 text-base"></i>
          </button>
        )}
        <div className="flex items-center gap-2">
          <i className="ri-keyboard-line text-gray-400"></i>
          <span className="text-xs text-gray-400 whitespace-nowrap">
            Powered by Biznify
          </span>
        </div>
      </div>
    </div>
  );
}
